export default __webpack_public_path__ + "static/media/beyondxlh_logo.2e1687ab.png";